<template>
  <span
    class="tw-inline-flex tw-items-center tw-justify-center tw-leading-none"
  >
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :aria-hidden="ariaHidden"
      focusable="false"
    >
      <path
        d="M5.49707 8.5459H0.875"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M5.1888 12.5459L2.10742 12.5459"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M5.49707 16.5459H0.875"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M23.92 6.56006L16 13.8201L8.07996 6.56006"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.07996 6.56006H23.92V17.7801C23.92 17.9551 23.8504 18.123 23.7266 18.2468C23.6029 18.3705 23.435 18.4401 23.26 18.4401H8.73996C8.56491 18.4401 8.39704 18.3705 8.27327 18.2468C8.14949 18.123 8.07996 17.9551 8.07996 17.7801V6.56006Z"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5603 12.5L8.28372 18.2536"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.7162 18.2536L17.4396 12.5"
        :stroke="[strokeColor ? '#FFF' : '#00A2E1']"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'Enquiries',
  props: {
    strokeColor: {
      type: Boolean,
      default: false,
    },
    ariaHidden: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
